import React, { useEffect, useRef } from "react";
import {Scrollbars} from "react-custom-scrollbars";

const CustomScrollbars = (props) => {
  // Default autoHide to true if not specified, but allow override
  const { autoHide = true, autoHideTimeout = 1000, autoHideDuration = 200, className = '', ...restProps } = props;
  const scrollbarsRef = useRef(null);
  
  // Force show scrollbar when content overflows on smaller screens
  useEffect(() => {
    if (scrollbarsRef.current && className.includes('gx-layout-sider-scrollbar')) {
      const forceShowScrollbar = () => {
        const view = scrollbarsRef.current?.view;
        if (view) {
          const hasOverflow = view.scrollHeight > view.clientHeight;
          
          // Find track element - it might be in different locations
          const wrapper = scrollbarsRef.current?.wrapper;
          let track = wrapper?.querySelector('.react-custom-scrollbars-track-vertical');
          if (!track) {
            track = view.parentElement?.querySelector('.react-custom-scrollbars-track-vertical');
          }
          if (!track) {
            track = document.querySelector('.gx-layout-sider-scrollbar .react-custom-scrollbars-track-vertical');
          }
          
          if (track) {
            if (hasOverflow) {
              // Force show scrollbar
              track.style.setProperty('opacity', '1', 'important');
              track.style.setProperty('visibility', 'visible', 'important');
              track.style.setProperty('display', 'block', 'important');
              
              // Also update thumb
              const thumb = track.querySelector('.react-custom-scrollbars-thumb-vertical');
              if (thumb) {
                thumb.style.setProperty('opacity', '0.6', 'important');
              }
            } else {
              // Hide if no overflow
              track.style.setProperty('opacity', '0', 'important');
            }
          }
        }
      };
      
      // Check immediately and after a short delay
      forceShowScrollbar();
      const timeout1 = setTimeout(forceShowScrollbar, 100);
      const timeout2 = setTimeout(forceShowScrollbar, 500);
      
      // Check on resize
      window.addEventListener('resize', forceShowScrollbar);
      
      // Use MutationObserver to detect content changes
      const observer = new MutationObserver(() => {
        setTimeout(forceShowScrollbar, 50);
      });
      
      if (scrollbarsRef.current?.view) {
        observer.observe(scrollbarsRef.current.view, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class'],
        });
      }
      
      // Also observe wrapper
      if (scrollbarsRef.current?.wrapper) {
        observer.observe(scrollbarsRef.current.wrapper, {
          childList: true,
          subtree: true,
          attributes: true,
        });
      }
      
      return () => {
        clearTimeout(timeout1);
        clearTimeout(timeout2);
        window.removeEventListener('resize', forceShowScrollbar);
        observer.disconnect();
      };
    }
  }, [className]);
  
  return (
    <Scrollbars
      {...restProps}
      ref={scrollbarsRef}
      autoHide={autoHide}
      autoHideTimeout={autoHideTimeout}
      autoHideDuration={autoHideDuration}
      renderTrackHorizontal={props => (
        <div
          {...props}
          style={{ display: 'none' }}
          className="track-horizontal"
        />
      )}
      renderTrackVertical={props => {
        // Always show track, let CSS handle visibility based on overflow
        return (
          <div
            {...props}
            className="react-custom-scrollbars-track-vertical"
            style={{
              ...props.style,
              opacity: '1',
              visibility: 'visible',
              display: 'block',
            }}
          />
        );
      }}
      renderThumbVertical={props => (
        <div
          {...props}
          className="react-custom-scrollbars-thumb-vertical"
          style={{
            ...props.style,
            cursor: 'pointer',
            borderRadius: '3px',
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        />
      )}
    />
  );
};

export default CustomScrollbars;
